module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaBAMAAABbZFH9AAAAJ1BMVEVHcEwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB+jSoGAAAADHRSTlMApUtVE/NI+jqFg4d8EzwWAAAARElEQVQY02NgwAfaz8BBBQODjRIcHAbyEMoweKkIXhgDAwuC58BANpgoCAfSDAwLETxJ8s1EdRmqq/H5DzUkUEMJNwAAIqQfSdYbh20AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/scanIcon.png
// module id = nyz9
// module chunks = 42